import React from "react";

interface SettingsIconProps {
  className?: string;
}

const SettingsIcon: React.FC<SettingsIconProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M1 3.75C1 2.784 1.784 2 2.75 2h10.5c.966 0 1.75.784 1.75 1.75V8h-.07L14 7.07V3.75a.75.75 0 0 0-.75-.75H2.75a.75.75 0 0 0-.75.75v6.5c0 .414.336.75.75.75h3.484A2.25 2.25 0 0 0 6 12H2.75A1.75 1.75 0 0 1 1 10.25zm10.116 3.616a1.25 1.25 0 0 1 1.767 0l1.75 1.75a1.25 1.25 0 0 1 0 1.768l-2.576 2.575L8.54 9.943zM7.94 10.541l-.575.575a1.25 1.25 0 0 0 0 1.768l1.75 1.749a1.25 1.25 0 0 0 1.767 0l.576-.575z"
    />
  </svg>
);

export default SettingsIcon;
